/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Version number, or 'latest' for the most recent version. Defaults to the skill's default_version.
 */
export type SkillReferenceVersion = string | number;

export type SkillReference = {
  type: "skill_reference";
  /**
   * ID of the skill to inject into the container.
   */
  skillId: string;
  /**
   * Version number, or 'latest' for the most recent version. Defaults to the skill's default_version.
   */
  version?: string | number | undefined;
};

/** @internal */
export const SkillReferenceVersion$inboundSchema: z.ZodType<
  SkillReferenceVersion,
  z.ZodTypeDef,
  unknown
> = z.union([z.string(), z.number().int()]);
/** @internal */
export type SkillReferenceVersion$Outbound = string | number;

/** @internal */
export const SkillReferenceVersion$outboundSchema: z.ZodType<
  SkillReferenceVersion$Outbound,
  z.ZodTypeDef,
  SkillReferenceVersion
> = z.union([z.string(), z.number().int()]);

export function skillReferenceVersionToJSON(
  skillReferenceVersion: SkillReferenceVersion,
): string {
  return JSON.stringify(
    SkillReferenceVersion$outboundSchema.parse(skillReferenceVersion),
  );
}
export function skillReferenceVersionFromJSON(
  jsonString: string,
): SafeParseResult<SkillReferenceVersion, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillReferenceVersion$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillReferenceVersion' from JSON`,
  );
}

/** @internal */
export const SkillReference$inboundSchema: z.ZodType<
  SkillReference,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("skill_reference"),
  skill_id: z.string(),
  version: z.union([z.string(), z.number().int()]).optional(),
}).transform((v) => {
  return remap$(v, {
    "skill_id": "skillId",
  });
});
/** @internal */
export type SkillReference$Outbound = {
  type: "skill_reference";
  skill_id: string;
  version?: string | number | undefined;
};

/** @internal */
export const SkillReference$outboundSchema: z.ZodType<
  SkillReference$Outbound,
  z.ZodTypeDef,
  SkillReference
> = z.object({
  type: z.literal("skill_reference"),
  skillId: z.string(),
  version: z.union([z.string(), z.number().int()]).optional(),
}).transform((v) => {
  return remap$(v, {
    skillId: "skill_id",
  });
});

export function skillReferenceToJSON(skillReference: SkillReference): string {
  return JSON.stringify(SkillReference$outboundSchema.parse(skillReference));
}
export function skillReferenceFromJSON(
  jsonString: string,
): SafeParseResult<SkillReference, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillReference$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillReference' from JSON`,
  );
}
